<template>
	<div :class="testimonial.url ? 'slide--content activeLink' : 'slide--content'" :style="defineStyle(testimonial)" @click.prevent="defineTarget(testimonial.url)">
		<span class="postType" :style="definePostType(testimonial)"></span>
		<img v-if="testimonial.companyLogo" class="client-logo" :alt="testimonial.companyLogo.url" :src="testimonial.companyLogo.url"/>
		<div class="text" v-html="testimonial.text"></div>
		<div class="flex signature">
			<div v-if="testimonial.clientPicture">
				<img class="client-picture" :alt="testimonial.clientPicture.url" :src="testimonial.clientPicture.url"/>
			</div>
			<div>
				<p class="title" v-html="testimonial.clientName"></p>
				<div v-html="testimonial.clientDescription"></div>
			</div>
		</div>
	</div>
</template>


<script>
import scrollBehavior  from '@/mixins/scrollBehavior.js'
import imgHandler  from '@/mixins/imgHandler.js'

export default {
	mixins: [scrollBehavior, imgHandler],
	props: ['testimonial'],
	methods:{
		defineTarget(url){
			if(!url){
				return
			}
			window.open(url);
		},
		defineStyle(testimonial){
			let styleObject = {
					color: '#fff',
					backgroundColor: "#000",
				};
			if(testimonial.bgColor){
				styleObject.backgroundColor = testimonial.bgColor; 
			}
			if(testimonial.textColor){
				styleObject.color = testimonial.textColor; 
			}
			return styleObject;
		},
		definePostType(testimonial){
			if(!testimonial.postType && !testimonial.colorLogo){
				return
			}
			let mode = testimonial.colorLogo == "Sombre" ? "-d" : "-l";
			let path = require('@/assets/img/'+testimonial.postType+mode+'.svg');
			return {
				background: 'url("'+path+'") no-repeat center'
			};
		}
	},
}
</script>

<style lang="scss">

	.slide--content{
		max-width:540px;
		padding: 30px 20px;
		border-radius:5px;
		position:relative;
		height: 500px;
		margin: 0;
		display: -webkit-flex;
		display: flex;
		flex-direction: column;
		justify-content:space-between;
		@include transform(scale(1));
		@include transition(transform .5s ease);
		@media screen and (min-width:767px){
			padding: 20px 50px 40px 50px;
			margin: 0 20px;
		}
		&.activeLink{
			cursor:pointer;
			&:hover{
				@include transform(scale(1.01));
			}
		}
		
		img{
			border-radius:100%;
		}
		.client-logo{
			width:70px;
			height:70px;
		}

		.postType{
			display:block;
			height: 26px;
			width: 26px;
			position:absolute;
			right:20px;
			top:20px;
		}

		.client-picture{
			width:60px;
			height:60px;
		}
		.text{
			margin: 3.3333rem 0;
			max-width:430px;
			line-height:1.6;
			font-size:1.333rem;
			@media screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2){
				font-size: 1.1rem;
			}
		}
		.signature > div:first-child{
			width:70px;
		}
		.signature > div:last-child{
			width:calc(100% - 70px);
		}
		.signature .title{
			font-size:1.06rem;
			font-family: 'surtBold_extended', Helvetica, Arial, sans-serif;
			margin-bottom:.4rem;
		}
		.signature p:not(.title){
			font-size: 0.8rem;
		}
		@media screen and (min-width:1024px) {
			height: 430px;
		}

	}

	
</style>